var scope_0 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/95afc7e3ece9fb4d4bcf6cede4a0d2c2.js').default;
var scope_1 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9b0d309a2065309fb508259e099cd7c1.js').default;
var scope_2 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_3 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fbdeacebbd82e0f59737dbf4b960f1c6.js').default;
var scope_4 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fc75ee9fddf5073da3e1510467102a7a.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4 )
    